import commonConfig from '@/baseData/carViolation/recordListUpdate'
import { operateMaxShowLength } from '@/store/dict/config'
import { getViolationDetail } from '@/api/domain/carsService'

function dealWithSearch(val) {
  const params = {}
  const { violationTime } = val
  if (violationTime && violationTime.length > 0) {
    params.fromTime = violationTime[0]
    params.toTime = violationTime[1]
  }
  return { ...params, ...val }
}
export default function () {
  const { tableData } = commonConfig.call(this, { isShowPlateNo: false, isIdClick: false })
  tableData.apiFn = getViolationDetail
  const formData = {
    formProps: { model: {} },
    dealWithSearch: this.dealWithSearch ? this.dealWithSearch : dealWithSearch,
  }
  const operateColumn = {
    name: 'operate',
    columnProps: {
      prop: 'operate',
      label: '操作',
      fixed: 'right',
    },
    maxShowLength: operateMaxShowLength,
    type: 'operate',
    getOperateList: ({ row }) => {
      const result = []
      if (this.judgePermission('vehicle_violation_record_list_detail')) {
        result.push({ name: 'detail', label: '详情', action: () => this.detail(row) })
      }
      if (this.judgePermission('vehicle_violation_record_list_solve') &&
          (row.handleState !== 1 || row.paymentState !== 1)) { // 已处理+已缴款 不展示
        result.push({ name: 'edit', label: '违章处理', action: () => this.violation(row) })
      }
      if (this.judgePermission('vehicle_violation_record_list_delete')) {
        result.push({ name: 'dele', label: '删除', action: () => this.openDel(row) })
      }
      if (this.judgePermission('vehicle_violation_record_list_way') && row.handleState === 1 && !row.dealViolationWay) {
        result.push({ name: 'handleDealViolationWay', label: '处理方式', action: () => this.openWay(row) })
      }
      return result
    },
  }
  return {
    formData,
    operateColumn,
    tableData,
    isShowDepartment: false,
  }
}
